import { Route, Routes } from 'react-router-dom'

import DigitalMarketingApproval from '@components/DigitalMarketingApproval'

import Overview from './screens/Overview'

const OrderEditRoutes = () => (
  <Routes>
    <Route path="/approval" element={<DigitalMarketingApproval nestedNavigation />} />
    <Route path="/overview" element={<Overview />} />
    {/* <Route path="/creative" element={<Creative />} /> */}
    {/* <Route path="/campaigns" element={<Campaigns />} /> */}
    {/* <Route path="/reporting" element={<Reporting />} /> */}
  </Routes>
)

export default OrderEditRoutes
